import { factory, getResponseCamelization } from '@repo-level/core-front';
import { CMS_URL, isCMSV3 } from 'helpers/conf';
import type { CMSApiBase, CMSLicenseContent } from './base';
import { buildCmsUrl, getResponseCMS } from './base';

export interface TermsAndConditionsApi extends CMSApiBase, CMSLicenseContent {
  title: string;
  titleH1: string;
  text: string;
  textLibergos: string;
  effectiveFrom: string;
  lastUpdated: string;
  version: string;
}

export const termsAndConditionsV3 = factory(
  (r) => (lang: string) =>
    r<TermsAndConditionsApi>(
      'get',
      `${CMS_URL}/terms-and-conditions?_locale=${lang}`
    )
);

export const termsAndConditionsV4 = factory(
  (r) => (lang: string) =>
    r<TermsAndConditionsApi>(
      'get',
      buildCmsUrl({
        path: 'terms-and-condition',
        lang,
        additionalParams: { 'populate[license_text]': '*' },
      }),
      undefined,
      { transformResponse: [getResponseCamelization(), getResponseCMS] }
    )
);

export const termsAndConditions = isCMSV3
  ? termsAndConditionsV3
  : termsAndConditionsV4;
